





















































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { documentNumberApi } from "@/getinfo-api";
import { NumberSequence as INumberSequence } from "@/api-v2/document-number/models/number-sequence";
import { getCurrentCompanyId } from "@/plugins/roles";
import { components, deleteComponent } from "@/utils/generate-helper";
import {
  bookkeepingModule,
  learningDocumentsModule
} from "@/plugins/modules-detect";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";
import list, {
  DocumentNumberingListParams
} from "@/getinfo-api/document-numbering";

@Component({
  components: { CSingleSelect, CField }
})
export default class DocumentNumberInput extends Vue {
  @Prop() type?:
    | "all"
    | "unset"
    | "contract"
    | "act"
    | "bill"
    | "learning_request"
    | "final_document"
    | "education_protocol"
    | "enrollment_order"
    | "expulsion_order";
  @Prop({ default: true }) labelVisible!: boolean;
  @Prop({ default: i18n.tc(LocalesFields.Number) }) label!: string;
  @Prop() placeholder!: string;
  @Prop() debounce!: number;
  @Prop() cy!: string;
  @Prop({ default: 4 }) lg!: number;
  backendError!: string;
  @Prop() backErr!: string;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: false }) disable!: boolean;
  @Prop({ default: () => [] }) validations!: Array<
    "required" | "phone" | "email" | string
  >;
  @Prop({ default: "default" }) validationKey!: string;
  @Prop() value?: any;
  @Prop({ default: true }) isShowList?: boolean;
  @Prop() companyId?: string;
  @Prop() xl?: number;
  @Prop() md?: number;
  body: any = "";
  isLoadingSequences?: boolean = false;
  options: Array<INumberSequence> = [];
  selectedSequence!: INumberSequence;
  searchOption: string = "";
  uniqId: string =
    "id" +
    Math.random()
      .toString(16)
      .slice(2);

  data() {
    return {
      selectedSequence: undefined
    };
  }

  get isShowListCheck() {
    return (
      this.isShowList && (bookkeepingModule() || learningDocumentsModule())
    );
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  get isNeedNextSequence() {
    return this.selectedSequence
      ? this.selectedSequence?.nextFreeValue === this.body
      : false;
  }

  get filteredOptionsByType() {
    const byType = this.options?.filter(el => el?.type === this.type);
    const another = this.options?.filter(el => el?.type !== this.type);

    return {
      typeOptions: byType,
      anotherOptions: another
    };
  }

  async nextMethod() {
    documentNumberApi
      .nextNumber(this.selectedCompanyId, this.selectedSequence.id)
      .then(() => {
        deleteComponent(this.uniqId);
      });
  }

  async nextSequenceGenerate() {
    this.isNeedNextSequence && this.isShowListCheck
      ? await this.nextMethod()
      : null;
  }

  async getSequences() {
    this.isLoadingSequences = true;
    try {
      const params: DocumentNumberingListParams = {
        title: this.searchOption ?? "",
        companyId: this.companyId ? this.companyId : this.selectedCompanyId,
        limit: 100,
        order: "DESC",
        sort: "title"
      };
      const { data } = await list(params);
      this.options = data;
    } catch (e) {
      throw new Error(e as any);
    } finally {
      this.isLoadingSequences = false;
    }
  }

  clearSearch() {
    this.searchOption = "";
  }

  selectValue(item: INumberSequence) {
    this.body = item.nextFreeValue;
    this.selectedSequence = item;
  }

  @Watch("value", { immediate: true })
  changeAttr() {
    this.body = this.value !== this.body ? this.value : this.body;
  }

  @Watch("body")
  changeValue() {
    this.$emit("input", this.body ? this.body : undefined);
  }

  created() {
    components.push(this);
  }

  beforeDestroy() {
    deleteComponent(this.uniqId);
  }
}
